import { createContext, useState } from "react";

export const CustomerContext = createContext();
const CustomerProvider = ({children}) =>{
    const [reloadCustomerUsers,setReloadCustomerUsers] = useState(false);
    const [selectedTenantAdminProfile,setSelectedTenantAdminProfile] = useState(null);
    const [unassignCustomerUser,setUnassignCustomerUser] = useState(null);
    const [selectedCustomerUser,setSelectedCustomerUser] = useState(null);
    const [selectedToDeleteCustomerUser,setSelectedToDeleteCustomerUser] = useState(null);
    return(
        <CustomerContext.Provider value={{
            reloadCustomerUsers,setReloadCustomerUsers,
            selectedTenantAdminProfile,setSelectedTenantAdminProfile,
            unassignCustomerUser,setUnassignCustomerUser,
            selectedCustomerUser,setSelectedCustomerUser,
            selectedToDeleteCustomerUser,setSelectedToDeleteCustomerUser
        }}>{children}</CustomerContext.Provider>
    );
};
export default CustomerProvider;